import api from './axiosInstance';
import { PlanType } from '../utils/planConfig';

export interface BillingStatus {
  plan: PlanType;
  trialEndsAt?: string;
  seatCount: number;
  activeUsers: number;
  projectCount: number;
  clientCount: number;
  subscription: {
    status: string;
    currentPeriodEnd: string;
    plan: PlanType;
  } | null;
}

export const getBillingStatus = async (): Promise<BillingStatus> => {
  const { data } = await api.get<BillingStatus>('/billing/status');
  return data;
};

export const createCheckoutSession = async (plan: PlanType, seats = 1): Promise<{ url: string }> => {
  const { data } = await api.post<{ url: string }>('/billing/checkout', { plan, seats });
  return data;
};

export const createPortalSession = async (): Promise<{ url: string }> => {
  const { data } = await api.post<{ url: string }>('/billing/portal');
  return data;
};
